import { ComboField } from '@components/Fields/ComboField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IForm } from '@hooks/useForm';
import { IComboEmpresa } from '@model/Empresa';
import { IComboOperadora } from '@model/Operadora';
import { IImportarRequest } from '@services/ContaService';
import React from 'react';
import { MenuItem } from '@material-ui/core';

export type ContaImportarFormularioProps = {
    form: IForm<IImportarRequest>
    empresaCombo: IComboEmpresa
    //operadoraCombo: IComboOperadora
    numerosContrato: string[]
}

export function ContaImportarFormulario ({ form, empresaCombo, numerosContrato }: ContaImportarFormularioProps) {
    const { fields } = form;

    return (
        <HorizontalGrid spacing={1}>
            <GridItem xs={2}>
                <ComboField 
                    field={fields.empresaId}
                    label="Empresa"
                >
                {
                    empresaCombo.createOptions()
                }
                </ComboField>
            </GridItem>

            {
                /*
            <GridItem xs={2}>
                <ComboField 
                    field={fields.operadoraId}
                    label="Operadora"
                >
                {
                    operadoraCombo.createOptions()
                }
                </ComboField>
            </GridItem>
                */
            }

            <GridItem xs={3}>
                <ComboField 
                    field={fields.numeroContrato}
                    label="Número Contrato"
                >
                {
                    numerosContrato.map(v => {
                        return <MenuItem key={v}>v</MenuItem>
                    })
                }
                </ComboField>
            </GridItem>
        </HorizontalGrid>
    )
}